import ApiService from '@/lib/ApiService'
import { PageType, PAGE_ENDPOINTS } from '@/constants/pageTypes'
import { logger } from '@/utils/logger'

export const localeService = {
    getCacheLanguagePreference: async (languageId: number) => {
        // eslint-disable-next-line no-useless-catch
        try {
            logger.debug('Fetching cache language preference:', { languageId })
            const response = await ApiService.fetchData<string>({
                url: `api/languages/getSignInPageTokens`,
                method: 'get',
                params: {
                    languageId: languageId,
                },
            })
            logger.debug('Cache language preference fetched successfully:', { 
                languageId, 
                dataLength: response.data?.length 
            })
            return response.data
        } catch (error) {
            logger.error('Failed to fetch cache language preference:', {
                languageId,
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined
            })
            throw error
        }
    },

    // Generic method that can handle any page type
    getPageLanguagePreference: async (
        languageId: number,
        pageType: PageType,
    ) => {
        try {
            logger.debug('Fetching page language preference:', { languageId, pageType })
            const response = await ApiService.fetchData<string>({
                url: PAGE_ENDPOINTS[pageType],
                method: 'get',
                params: { languageId },
            })
            logger.debug('Page language preference fetched successfully:', { 
                languageId, 
                pageType,
                dataLength: response.data?.length 
            })
            return response.data
        } catch (error) {
            logger.error('Failed to fetch page language preference:', {
                languageId,
                pageType,
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined
            })
            throw error
        }
    },
}
